import { createApp } from 'vue';
import ProductsSidebar from '../components/ProductsSidebar.vue';

const productsSidebarEl = document.getElementById('products-sidebar-app');

if (productsSidebarEl) {
  let productsData = {
    producten: [],
    'eten-drinken': [],
    verpakking: [],
    brievenbus: [],
  };

  try {
    const dataAttr = productsSidebarEl.getAttribute('data-products');
    if (dataAttr && dataAttr.trim() !== '') {
      productsData = JSON.parse(dataAttr);
    }
  } catch (error) {
    console.error('Failed to parse products data:', error);
  }

  const app = createApp(ProductsSidebar, {
    products: productsData,
  });

  app.mount('#products-sidebar-app');
}
